import { Toast } from "antd-mobile";

export default {
  /**
   * formatTime - 格式化时间
   * @param  {time} 标准时间格式
   * @param  {String}  format 时间格式结构，比如 yyyy-MM-dd HH:mm:ss
   * @return {String} 格式化后的时间
   */
  formatTime: function (time: any, format?: any) {
    if (typeof time === 'string') {
      time = time.replace(/-/g, '/')
    }
    var t = new Date(time);
    var sFormat = format || 'yyyy-MM-dd HH:mm:ss';
    var tf = function (i: any) {
      return (i < 10 ? '0' : '') + i
    };

    return sFormat.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a: any) {
      switch (a) {
        case 'yyyy':
          return tf(t.getFullYear());
          break;
        case 'MM':
          return tf(t.getMonth() + 1);
          break;
        case 'mm':
          return tf(t.getMinutes());
          break;
        case 'dd':
          return tf(t.getDate());
          break;
        case 'HH':
          return tf(t.getHours());
          break;
        case 'ss':
          return tf(t.getSeconds());
          break;
      }
    });
  },
  // 判断时间格式是否正确
  isValidDate: function(date: any) {
    return date instanceof Date && !isNaN(date.getTime())
  },
  /**
   * @function ISO时间格式化
   */
    getFormatIsoTime: function (time: any, flaggmt: any, format: any) {
    if (!time) return '';
    // if (typeof time === 'string') {
    //   time = time.replace(/-/g, '/')
    // }
    if (!this.isValidDate(new Date(time))) return time;
    var timeArr = time.split(/\T|\+|\-/);
    var isoTime = new Date(timeArr[0] + '/' + timeArr[1] + '/' + timeArr[2] + ' ' + timeArr[3]);
    var formatIsoTime = '';
    if (flaggmt) {
      formatIsoTime = this.formatTime(isoTime, format) + ' ' + this.getGMT();
    } else {
      formatIsoTime = this.formatTime(isoTime, format);
    }
    return formatIsoTime;
  },
  /**
   * @function UTC时间转本地时间
   */
  getLocalTime: function (time: any, flaggmt: any, format: any) {
    if (!time) return '';
    if (typeof time === 'string') {
      time = time.replace(/-/g, '/')
    }
    var localTime = '';
    if (flaggmt) {
      localTime = this.formatTime(time, format) + ' ' + this.getGMT();
    } else {
      localTime = this.formatTime(time, format);
    }
    return localTime;
  },
  getZeroTime(time: any, flaggmt: any, format: any) {
    if (!time) return '';
    if (typeof time === 'string') {
      time = time.replace(/-/g, '/')
    }
    let localTime = '';
    const { hour, min }: any = this.getGMT(true)
    const timeStr = new Date(time).valueOf() + (hour * 60 * 60 * 1000) + (min * 60 * 1000)
    if (flaggmt) {
      localTime = this.formatTime(timeStr, format) + ' ' + this.getGMT();
    } else {
      localTime = this.formatTime(timeStr, format);
    }
    return localTime;
  },
  /**
   * @function 得到GMT格式
   * @description 详细内容参见yqtrack.web.uikit-v2\global-extend\vendor-yq\__utils\datetime-extend.js
   */
  getGMT: function (flag?: boolean) {

    var dt = new Date();
    var iOffset = dt.getTimezoneOffset(); //当地时间与GMT时间的偏移

    var sHour: any = Math.floor(Math.abs(iOffset / 60));
    var sMin: any = Math.abs(iOffset % 60);

    if (flag) {
      return {
        hour: sHour,
        min: sMin
      }
    }

    var sGMT;

    if (sHour < 10) {
      sHour = '0' + sHour;
    }
    if (sMin < 10) {
      sMin = '0' + sMin;
    }

    if (iOffset < 0) {
      sGMT = '(GMT' + '+' + sHour + ':' + sMin + ')';
    } else if (iOffset > 0) {
      sGMT = '(GMT' + '-' + sHour + ':' + sMin + ')';
    } else {
      sGMT = '(GMT+00:00)';
    }
    return sGMT;
  },
  /**
   * @function 得到GMT格式
   * @description 详细内容参见yqtrack.web.uikit-v2\global-extend\vendor-yq\__utils\string-extend.js
   */
  leftFillZero: function (str: any, n: any) {

    var newString;
    var oriLen = String(str).length;
    var maxLen = n;
    var zero = '';
    var i = 0;

    if (maxLen) {
      while (i < maxLen - oriLen) {
        zero += '0';
        i++;
      }
      newString = zero + str;
    } else {
      newString = '0' + str;
    }
    return newString;
  },
  //
  /**
   * @function 格式化预定字符串
   * @description 详细内容参见yqtrack.web.uikit-v2\global-extend\vendor-yq\__utils\string-extend.js
   */
  strFormat: function (str: any, array: any) {

    var reg;
    var i = 0;
    var length = array.length;

    if (Object.prototype.toString.call(array) === '[object Array]') {

      for (; i < length; i++) {

        if (array[i] !== undefined) {

          reg = new RegExp('({)' + i + '(})', 'g');
          str = str.replace(reg, array[i]);

        }

      }
    } else {

      console.log('=>格式化参数不是一个数组');

    }

    return str;
  },
  /**
   * @function 按key参数，替换str中前后对应的符号为空字符
   * @description 详细内容参见yqtrack.web.uikit-v2\global-extend\vendor-yq\__utils\string-extend.js
   */
  trimStr: function (str: any, key: any) {

    var last;

    if (str.substring(0, 1) == key) {

      str = str.substr(1);

    }

    last = str.substr(str.length - 1);

    if (last == key) {
      str = str.substring(0, str.length - 1);
    }

    return str;
  },
  /**
   * [format 字符串占位符格式化]
   * @param result {String} 字符串内容
   * @param args args 必须是一个数组
   * @return {String}  格式化后的字符串
   * eg: YQStr.format("词条{0}{1}"，['参数1','参数2']);
   */
  format: function (result: any, args: any) {
    var reg;
    if (Object.prototype.toString.call(args) === '[object Array]') {
        for (var i = 0; i < args.length; i++) {
            if (args[i] !== undefined) {
                reg= new RegExp('({)' + i + '(})', 'g');
                result = result.replace(reg, args[i]);
            }
        }
    }else{
        console.log(result+'=>格式化参数不是一个数组');
    }

    return result;
  },
  h5Copy: (content: string) => {
    if (!document.queryCommandSupported('copy')) {
      // 不支持
      return false
    }
  
    let textarea = document.createElement("textarea")
    textarea.value = content
    textarea.readOnly = true
    document.body.appendChild(textarea)
    textarea.select() // 选择对象
    textarea.setSelectionRange(0, content.length) //核心
    let result = document.execCommand("copy") // 执行浏览器复制命令
    textarea.remove()
    return result
  },
  copy: function(params: { text: string, copySuccessMsg: string }) {
    if (!params.text) return
    if (this.h5Copy(params.text)) {
      Toast.show(params.copySuccessMsg)
    }
  },
  getErrorDesc: function ($t: any, code: string | number, ...args: any) {
    let result = '';
    const key = code == 0 ? code : '-' + code.toString().replace('-', '');
  
    const dict = $t(`ResGErrorCode.items.itemsDict.data.${key}`);
  
    if (dict) {
      result = dict._desc;
      if (result && args.length) {
        result = this.strFormat(result, args)
      }
    }
  
    return result;
  }
}